<div class="system-connection-details-dialog">
  <h2 mat-dialog-title>{{data.name}} Details</h2>
  <mat-dialog-content>
    <div class="details-container" fxLayout="column" fxLayoutGap="16px">
      <div *ngFor="let detail of details" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
        <strong>{{detail.key}}:</strong>
        <span>{{detail.value}}</span>
        <mat-icon *ngIf="detail.key === 'status'"
          [class]="detail.value === 'true' ? 'check_circle' : 'cancel'">{{detail.value === 'true' ? 'check_circle' :
          'cancel'}}</mat-icon>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="onClose()">Close</button>
  </mat-dialog-actions>
</div>